"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.destroyDropletAndAllAssociatedResources = void 0;
const destroyDropletAndAllAssociatedResources = ({ httpClient, }) => ({ acknowledge, droplet_id, }) => {
    const path = '/droplets';
    const url = `${path}/${droplet_id}/destroy_with_associated_resources/dangerous`;
    const headers = {
        'X-Dangerous': `${acknowledge}`,
    };
    return httpClient.delete(url, { headers, data: undefined });
};
exports.destroyDropletAndAllAssociatedResources = destroyDropletAndAllAssociatedResources;
//# sourceMappingURL=destroy-droplet-and-all-associated-resources.js.map